// We use Lens server for grafana since that's where SQL is setup
import AxiosConfig from '../lens/LensAxiosConfig'
import firebase from '../config/FirebaseConfig'

const sendEvent = async (onboardStage) => {
  if (!['REGISTER', 'TEAM', 'PERSONALIZE', 'PLAN', 'PAYMENT', 'FINISH'].includes(onboardStage)) {
    throw new Error('Invalid onboarding stage')
  }

  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/user-operations/signup-stage',
    { step: onboardStage },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const sendPersonalizationInfo = async (payload) => {
  if (!payload?.industry || !payload?.referrer) {
    throw new Error('Missing personalization data')
  }
  const { industry, referrer } = payload

  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/user-operations/signup-attributes',
    { 
      persona: industry,
      source: referrer
    },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const sendPlanInfo = async (payload) => {
  if (!payload?.plan || !payload?.interval) {
    throw new Error('Missing plan info data')
  }
  const { plan, interval } = payload

  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/user-operations/signup-plan',
    { 
      plan,
      interval
    },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

export default {
  sendEvent,
  sendPersonalizationInfo,
  sendPlanInfo
}